export const formatCpfCnpj = (value) => {
  // 1. 移除所有非字母数字字符
  const cleaned = value.replace(/[^a-zA-Z0-9]/g, '');

  // 2. 根据长度判断
  if (cleaned.length === 11) {
    // CPF: 000.000.000-00
    return `${cleaned.slice(0, 3)}.${cleaned.slice(3, 6)}.${cleaned.slice(6, 9)}-${cleaned.slice(9, 11)}`;
  } else if (cleaned.length === 14) {
    // CNPJ (兼容纯数字和字母): 00.000.000/0000-00 或 00.ABC.345/01DE-35
    return `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(5, 8)}/${cleaned.slice(8, 12)}-${cleaned.slice(12, 14)}`;
  }
  // 长度不对时，返回原值或清理后的值
  return cleaned;
};
